export default function () {

  var ua = navigator.userAgent.toLowerCase(),
    isiPad = ua.indexOf('ipad') != -1,
    isiPad_above13 = ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && 'ontouchend' in document;
  var ipad = ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && 'ontouchend' in document;

  if ( !navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/) ) {
    if ( isiPad_above13 == false) {

      var body = document.body;
      var pointer = document.createElement("div");
      pointer.className = "c-pointer";
      body.appendChild(pointer);

      // 遷移前の座標を取得、あればその位置にポインタを移動させる
      const
        historyX = sessionStorage.getItem('historyX'),
        historyY = sessionStorage.getItem('historyY');
      if(historyX && historyY) {
        pointer.style.transform = 'translate(' + historyX + 'px, ' + historyY + 'px)';
      }

      body.addEventListener("mousemove", function(e) {
        pointer.style.transform = 'translate(' + e.clientX + 'px, ' + e.clientY + 'px)';
        // 遷移前の座標の取得用にセッションストレージに座標を保存
        sessionStorage.setItem('historyX', e.clientX);
        sessionStorage.setItem('historyY', e.clientY);
      });
      // $('.c-pointer').append('<div class="c-pointer__inner" />');
      $('.c-pointer')
        .append('<div class="c-pointer__inner" />')
        .hide()
        .fadeIn(300);
      $pointer = $('.c-pointer');

      var hoverSize = 60;
      var defaultWd = $pointer.css('width');
      var defaultHgt = $pointer.css('height');
      var defaultTop = $pointer.css('top');
      var defaultLeft = $pointer.css('left');
      $("a, button, input[type='submit']").on("mouseenter", function() {
          TweenMax.to($pointer, .25, {
            width: hoverSize + 'px',
            height: hoverSize + 'px',
            top: -(hoverSize/2) + 'px',
            left: -(hoverSize/2) + 'px',
            opacity: .6
          });
      }).on("mouseleave", function() {
          TweenMax.to($pointer, .25, {
            width: defaultWd,
            height: defaultHgt,
            top: defaultTop,
            left: defaultLeft,
            opacity: .8
          });
      });

      $(".is-dark-hover").on("mouseenter", function() {
        $(pointer).addClass('is-dark');
      }).on("mouseleave", function() {
        $(pointer).removeClass('is-dark');
      });

    }
  }
}
